import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';

import './ConditionResponse.scss';

import { bindActionCreators } from 'redux';
import { ItemsCreators } from 'store/actions/items';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import Switch from '@material-ui/core/Switch';
import { UserActions } from 'store/actions/users';
import SettingsCard from '../../SettingsCard/SettingsCard';
import { IaCreators } from '../../../../../store/actions/intelligence';

const PurpleSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: 'white',
    },
    '&$checked + $track': {
      backgroundColor: '#0D84FF',
      opacity: 1,
    },
  },
  checked: {},
  track: {},
})(Switch);

function ConditionResponse(props) {
  const { blt, modal, openModal, user } = props;

  useEffect(() => {
    props.listConditions(props.match.params.botid || '');
    props.getAllItems({ botId: props.match.params.botid || '' });
    props.bot.iaEnabled && props.listIAIntents(props.bot.currentTokenIa);
    props.bot.iaEnabled && props.listIAEntities(props.bot.currentTokenIa);
  }, []);

  const onChangeActiveCondition = (e, condition) => {
    props.updateCondition({ _id: condition._id, active: !condition.active });
  };

  const getInformations = (condition) => {
    const item = props.items.find((item) => item._id === condition.destination);
    return `${item?.title || ''} ${item?._id || ''}`;
  };

  const deleteCondition = (id) => {
    props.deleteCondition(id);
  };

  const setEditCondition = (condition) => {
    openModal();
    props.setEditCondition(condition);
  };

  const renderCondition = (condition) => {
    if (condition.intent && condition.entity) {
      return (
        <>
          Se intenção for igual a <strong>{condition.intent} </strong> e
          entidade for igual a <strong>{condition.entity} </strong>
          vá para{' '}
          <strong>
            {getInformations(condition).split(' ').slice(0, -1).join(' ')}{' '}
          </strong>
          quando a confiança for maior ou igual que{' '}
          <strong>{condition.confidence}%</strong>
        </>
      );
    }
    if (condition.intent) {
      return (
        <>
          Se intenção for igual a <strong>{condition.intent} </strong>
          vá para{' '}
          <strong>
            {getInformations(condition).split(' ').slice(0, -1).join(' ')}{' '}
          </strong>
          quando a confiança for maior ou igual que{' '}
          <strong>{condition.confidence}%</strong>
        </>
      );
    }
    return (
      <>
        Se entidade for igual a <strong>{condition.entity} </strong>
        vá para{' '}
        <strong>
          {getInformations(condition).split(' ').slice(0, -1).join(' ')}{' '}
        </strong>
        quando a confiança for maior ou igual que{' '}
        <strong>{condition.confidence}%</strong>
      </>
    );
  };

  return (
    <div className="modal-condition">
      {modal === false && (
        <div className="select-modal">
          <button
            className={[
              'btn-condicao',
              props?.bot?.iaEnabled ? '' : 'btn-disabled',
            ].join(' ')}
            disabled={
              props?.bot?.iaEnabled
                ? null
                : !!(
                    'disabled' ||
                    user?.selectedCompany?.claim?.name === 'Viewer'
                  )
            }
            onClick={
              user?.selectedCompany?.claim?.name !== 'Viewer' ? openModal : ''
            }
          >
            criar nova condição
          </button>
        </div>
      )}

      {props.bot.iaEnabled &&
        props.conditions
          .filter((condition) => condition.version === 0)
          .map((condition) => (
            <div
              className="response-card"
              key={`conditionResponse${condition._id}`}
            >
              <div>
                <span>{renderCondition(condition)}</span>
              </div>
              <div>
                <PurpleSwitch
                  checked={condition.active}
                  onChange={(e) => onChangeActiveCondition(e, condition)}
                />
                <SettingsCard
                  deleteItem={() => deleteCondition(condition._id)}
                  editItem={() => setEditCondition(condition)}
                  user={user}
                  blt={blt}
                />
              </div>
            </div>
          ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  conditions: state.intelligence.conditions,
  items: state.items.allItems,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...IaCreators, ...ItemsCreators, ...UserActions },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ConditionResponse))
);
